export class AddOnsCalcLimitsAfterUpgradeDTO {
    baseMaxUsers: number = 0;
    baseMaxWarehouses: number = 0;
    includedUsersPerWarehouse: number = 0;
    effectiveMaxUsers: number = 0;
    effectiveMaxWarehouses: number = 0;
    currentActivePaidUsers: number = 0;
    currentActiveWarehouses: number = 0;
    activePaidUsersAfterUpgrade: number = 0;
    activeWarehousesAfterUpgrade: number = 0;
    remainingPaidUserSlots: number = 0;
    bundledUsersFromWarehouseAddons: number = 0;
    bundledUsersFromServiceTruckAddons: number = 0;
    includedUsersPerServiceTruck: number = 0;
    totalCurrentUserLimit: number = 0;

    constructor(data: Partial<AddOnsCalcLimitsAfterUpgradeDTO> = {}) {
        Object.assign(this, data);
    }
}

export class AddOnsCalcWarehouseBreakdownDTO {
    purchasedQuantity: number = 0;
    expiredReactivated: number = 0;
    scheduledReactivated: number = 0;
    billableQuantity: number = 0;
    unitPrice: string = '0';
    lineTotal: number = 0;
    bundledPaidUserSlotsIncluded: number = 0;

    constructor(data: Partial<AddOnsCalcWarehouseBreakdownDTO> = {}) {
        Object.assign(this, data);
    }
}

export class AddOnsCalcUserBreakdownDTO {
    purchasedQuantity: number = 0;
    expiredReactivated: number = 0;
    scheduledReactivated: number = 0;
    bundledFromWarehouseReactivation: number = 0;
    billableExpiredReactivated: number = 0;
    billableQuantity: number = 0;
    unitPrice: string = '0';
    lineTotal: number = 0;
    includedUsersPerWarehouse: number = 0;

    constructor(data: Partial<AddOnsCalcUserBreakdownDTO> = {}) {
        Object.assign(this, data);
    }
}

export class AddOnsCalcServiceTruckBreakdownDTO {
    purchasedQuantity: number = 0;
    expiredReactivated: number = 0;
    scheduledReactivated: number = 0;
    billableQuantity: number = 0;
    unitPrice: string = '0';
    lineTotal: number = 0;
    bundledPaidUserSlotsIncluded: number = 0;
    includedUsersPerServiceTruck: number = 0;

    constructor(data: Partial<AddOnsCalcServiceTruckBreakdownDTO> = {}) {
        Object.assign(this, data);
    }
}

export class AddOnsCalcBreakdownDTO {
    warehouses: AddOnsCalcWarehouseBreakdownDTO = new AddOnsCalcWarehouseBreakdownDTO();
    users: AddOnsCalcUserBreakdownDTO = new AddOnsCalcUserBreakdownDTO();
    serviceTrucks: AddOnsCalcServiceTruckBreakdownDTO = new AddOnsCalcServiceTruckBreakdownDTO();

    constructor(data: Partial<AddOnsCalcBreakdownDTO> = {}) {
        this.warehouses = new AddOnsCalcWarehouseBreakdownDTO(data.warehouses);
        this.users = new AddOnsCalcUserBreakdownDTO(data.users);
        this.serviceTrucks = new AddOnsCalcServiceTruckBreakdownDTO(data.serviceTrucks);
    }
}

export class AddOnsCalcResponseDTO {
    companySubscriptionId: string = '';
    currency: string = '';
    isTrial: boolean = false;
    immediateChargeAmount: number = 0;
    monthlyRecurringIncrease: number = 0;
    limitsAfterUpgrade: AddOnsCalcLimitsAfterUpgradeDTO = new AddOnsCalcLimitsAfterUpgradeDTO();
    breakdown: AddOnsCalcBreakdownDTO = new AddOnsCalcBreakdownDTO();
    note: string = '';

    constructor(data: Partial<AddOnsCalcResponseDTO> = {}) {
        Object.assign(this, data);
        this.limitsAfterUpgrade = new AddOnsCalcLimitsAfterUpgradeDTO(data.limitsAfterUpgrade);
        this.breakdown = new AddOnsCalcBreakdownDTO(data.breakdown);
    }
}
